import React from "react";

import { Building2 } from 'lucide-react';
import InputSiren from "@app/components/2_widgets/inputs/InputSiren";

export default function SectionSiren({createCustomer}) {
    return (
        <div className="page-section">
            <div className="section-title">
                <h2 className="title"><Building2 /> Recherche entreprise</h2>
                <span className="subtitle">Entrez le numéro SIREN pour récupérer les informations</span>
            </div>
            <InputSiren callback={createCustomer} />
        </div>
    )
}